"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.padHexString = exports.getDefaultFeeUnit = exports.isEthereumAddress = void 0;
const isEthereumAddress = (address) => /^0x[0-9a-fA-F]{40}$/.test(address);
exports.isEthereumAddress = isEthereumAddress;
const getDefaultFeeUnit = (currency) => currency.units.length > 1 ? currency.units[1] : currency.units[0];
exports.getDefaultFeeUnit = getDefaultFeeUnit;
const padHexString = (str) => {
    return str.length % 2 !== 0 ? "0" + str : str;
};
exports.padHexString = padHexString;
exports.default = {
    isEthereumAddress: exports.isEthereumAddress,
    getDefaultFeeUnit: exports.getDefaultFeeUnit,
    padHexString: exports.padHexString,
};
//# sourceMappingURL=logic.js.map